import { Outlet, createFileRoute } from '@tanstack/react-router'

import { CoursesView } from '@/modules/courses'

export const Route = createFileRoute('/_auth/courses')({
  component: () => (
    <CoursesView>
      <Outlet />
    </CoursesView>
  )
})
